import { Injectable } from '@angular/core';
import { Headers, Http, Response } from '@angular/http';
import { Observable, Subject } from 'rxjs';
import 'rxjs/add/operator/map'
import { ConfigService } from "../config/config.service";
import { Config } from "../config";
import { Storage } from '@ionic/storage';
import { HttpClient } from '@angular/common/http';
import { CardLoginData } from '../../app/models/CardLoginData';


@Injectable()
export class AuthenticationService {
  public token: string;
  private currentConfiguration: Config;
  requestInterceptedSource: Subject<number> = new Subject<number>();
  requestIntercepted: Observable<number> = this.requestInterceptedSource.asObservable();

  constructor(private http: Http,
    private httpClient: HttpClient,
    private configService: ConfigService,
    private storage: Storage) {
    // set token if saved in local storage
    // var currentUser = JSON.parse(localStorage.getItem('currentUser'));
    // this.token = currentUser && currentUser.token;

    this.currentConfiguration = this.configService.getConfiguration();

  }

  getCardLoginData<T>(uuid: String): Observable<CardLoginData> {
    let url = this.configService.getUrl() + "cards/" + uuid + "/logindata";
    let response = this.httpClient.get<CardLoginData>(url);
    return response;
  }

  login(username: string, password: string): Observable<any> {
    let contentHeaders: Headers = new Headers({ "Content-Type": "application/json" });

    let url = this.configService.getUrl() + "signin";

    let responseObservable = this.http.post(url,
      JSON.stringify({ username: username, password: password }),
      { headers: contentHeaders });
    return responseObservable
      .map((response: Response) => {
        let json = response.json();
        // login successful if there's a jwt token in the response
        let token = json && json.token;

        if (token) {
          // set token property
          this.token = token;
        }
        return json;
      });
  }

  logout(): Observable<Response> {
    let headers: Headers = new Headers({ 'Authorization': "Bearer " + this.token });
    let url = this.configService.getUrl() + "signout";
    let responseObservable = this.http.post(url,
      "",
      { headers: headers });
    return responseObservable
      .do((response: Response) => {
        // clear token remove user from local storage to log user out
        this.token = null;
      });
  }

  checkPin(username: string, pin: string): Observable<any> {
    let contentHeaders: Headers = new Headers({ "Content-Type": "application/json" });
    let url = this.configService.getUrl() + "signin";
    let responseObservable = this.http.post(url,
      JSON.stringify({ username: username, password: pin }),
      { headers: contentHeaders });
    return responseObservable
      .map((response: Response) => {
        return response.json();
      });
  }
}



// WEBPACK FOOTER //
// ./src/providers/authentication/authenticationService.ts